export default __webpack_public_path__ + "static/media/file-excel-outline.56dc4ec3.svg";